import rdImg from "../assets/img/cards-dark.png";
import useScrollAnimation from "../hooks/useScrollAnimation";

const RoadMap = () => {
  const titleRef = useScrollAnimation();

  return (
    <div className="py-[61px] md:py-[100px] roadmap-bg w-full bg-[#252427] relative overflow-hidden">
      {/* Background glow */}
      <div className="absolute bottom-0 right-0 w-[400px] h-[400px] bg-[#15D9E8] opacity-[0.04] rounded-full blur-[120px]" />

      <div className="container mx-auto px-[6%]">
        <div ref={titleRef} className="animate-on-scroll">
          <h3 className="text-[26px] md:text-[47px] text-center font-bold font-Poppins text-white mb-8 md:mb-12">
            <span className="gradient-text">Project Roadmap</span>
          </h3>
        </div>

        <div className="relative">
          {/* Timeline line - desktop only */}
          <div className="timeline-line hidden lg:block" />

          <div className="space-y-4 lg:space-y-6">
            {roadmap.map(({ id, title, status, li }, index) => (
              <RoadmapPhase
                key={id}
                id={id}
                title={title}
                status={status}
                li={li}
                index={index}
                rdImg={rdImg}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

const RoadmapPhase = ({ id, title, status, li, index, rdImg }) => {
  const ref = useScrollAnimation();
  const isLeft = index % 2 === 0;

  return (
    <div
      ref={ref}
      className={`animate-on-scroll ${isLeft ? "from-left" : "from-right"} relative`}
    >
      {/* Timeline dot */}
      <div className="hidden lg:block absolute left-1/2 top-8 -translate-x-1/2 z-10">
        <div className={`pulse-dot ${status === "done" ? "!bg-[#15D9E8]" : ""}`} />
      </div>

      {/* Mobile timeline dot */}
      <div className="lg:hidden absolute left-[20px] top-8 z-10">
        <div className={`pulse-dot ${status === "done" ? "!bg-[#15D9E8]" : ""}`} />
      </div>

      <div
        className={`lg:w-[45%] ${
          isLeft ? "lg:mr-auto lg:pr-12" : "lg:ml-auto lg:pl-12"
        } ml-12 lg:ml-0`}
      >
        <div className="content-box p-6 md:p-8">
          <div className="flex items-center gap-4 mb-5">
            <div className="relative shrink-0">
              <div className="border-[4px] border-[#15D9E8] rounded-b-[30px] rounded-tl-[30px] overflow-hidden w-[60px] h-[60px] flex items-center justify-center">
                <img
                  className="w-full h-full object-cover"
                  src={rdImg}
                  alt="roadmap"
                />
                <p className="absolute inset-0 m-auto text-white z-10 w-max h-max text-[28px] font-BowlbyOneSC drop-shadow-lg">
                  {id}
                </p>
              </div>
            </div>
            <div>
              <h4 className="font-Poppins text-xl md:text-2xl font-bold text-white">
                {title}
              </h4>
              {status === "done" && (
                <span className="text-xs font-Poppins font-bold uppercase tracking-wider text-[#15D9E8]">
                  Completed
                </span>
              )}
              {status === "active" && (
                <span className="text-xs font-Poppins font-bold uppercase tracking-wider text-[#E71CA5]">
                  In Progress
                </span>
              )}
            </div>
          </div>
          <ul className="space-y-2">
            {li.map((text, i) => (
              <li key={i} className="flex items-start gap-2">
                <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-[#E71CA5] shrink-0" />
                <p className="text-sm md:text-base font-Poppins text-white/70">
                  {text}
                </p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default RoadMap;

const roadmap = [
  {
    id: 1,
    title: "Foundation & Awareness",
    status: "done",
    li: [
      "Website launched at shinyheffers.io",
      "Official channels live: Instagram, Facebook, LinkedIn, X",
      "$SHIT BEP-20 token deployed on Binance Smart Chain",
      "SHIT-3UF0 KDA deployed on KleverChain (dual-chain from day one)",
      "Season One Goon Squad NFTs minted and listed on OpenSea",
      "Marketing campaigns, AMAs, and influencer rollouts active",
    ],
  },
  {
    id: 2,
    title: "Platform & DEX Build-out",
    status: "done",
    li: [
      "Token security pass: BSC contract taxes zeroed, anti-whale cap lifted, auto-liquidity disabled (GoPlus / Honeypot rescans clean for runtime behavior)",
      "ShitSwap launched at /shitswap — single UI for BSC swaps via PancakeSwap V2 and KleverChain swaps via the on-chain DEX router",
      "Wallet support: MetaMask, WalletConnect, Coinbase, Trust (BSC) plus Klever Extension (KleverChain)",
      "Live charts at /prices — GeckoTerminal embed for BSC + bitcoin.me embed for KleverChain",
      "White Paper v3 embedded at /whitepaper",
    ],
  },
  {
    id: 3,
    title: "Maturity & Exchange Listings",
    status: "active",
    li: [
      "BSC v1 ownership: transfer to 2-of-3 multisig + 48h timelock, then renounce admin paths",
      "CoinMarketCap and CoinGecko listings",
      "Digiko liquidity expansion and visibility partnerships",
      "Tier-2 CEX listings: Coinstore, LBank, MEXC, XT.com, BKEX",
      "Deploy custom FeeRouter contracts on BSC and KleverChain to collapse the current 2-step swap into a single signature",
    ],
  },
  {
    id: 4,
    title: "Multi-Chain v2 via LayerZero OFT",
    status: "pending",
    li: [
      "Deploy ShinyHeffersV2 on Ethereum, Base, Solana, and Sui (100B unified supply, 9 decimals EVM / 8 decimals non-EVM)",
      "LayerZero V2 OFT links all five chains — burn-on-send, mint-on-receive, total supply stays constant",
      "BSC OFTAdapter wraps the existing v1 token so legacy holders never need to migrate",
      "Seed liquidity: Uniswap V3 (ETH + Base), Raydium (Solana), Cetus (Sui)",
      "Multisig + timelock applied per chain before peer wiring is finalized",
    ],
  },
  {
    id: 5,
    title: "NFT Ecosystem Expansion",
    status: "pending",
    li: [
      "Season Two NFT \"Cows\" — each NFT backed by a real-world cow with ownership rights and profit-sharing benefits",
      "NFT Farming and Play-to-Earn mechanics for community participation",
      "Metaverse integration for tokenized farming and livestock experiences",
    ],
  },
  {
    id: 6,
    title: "Real Goods & Investor Platform",
    status: "pending",
    li: [
      "D2C produce + beef subscriptions delivering bundled nutrient-dense food",
      "Modular vertical farm deployments in urban centers",
      "Investor education hub and governance framework for $SHIT holders",
      "Profit-sharing distributions to long-term holders and stakers",
    ],
  },
];
